import PublisherActions from '../../../../actions/PublisherActions';
import UserInfoActions from '../../../../actions/UserInfoActions';
import CustomNotify from '../../../Notify';

export const actions = {
    settingsSave(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;
        let params = {
            anonymous: state.anonymous ? '1' : '0',
            subscribed: state.subscribed ? '1' : '0',
            timezone: state.timezone,
            contacts: JSON.stringify(state.contacts),
        };

        PublisherActions.edit(params).then(data => {
            UserInfoActions.loadInfo();

            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};
